import { useRef, useState } from "react";
import { normalizeUiPalette } from "./crmColors";

// Versions belong to one mounted app session. Reads cannot undo a pending write.
export function createUiPaletteSession(onChange) {
  let revision = 0, value = "cchat", confirmed = false;
  const pending = new Set();
  return {
    setUiPalette(next, isConfirmed = true) {
      revision += 1; value = normalizeUiPalette(next); confirmed = isConfirmed;
      if (!isConfirmed) pending.clear();
      onChange(value);
    },
    getUiPalette: () => confirmed ? value : undefined,
    getUiPaletteRevision: () => revision,
    getUiPaletteReadRevision: () => pending.size ? null : revision,
    beginUiPaletteSave() {
      revision += 1;
      const token = {}; pending.add(token);
      return () => pending.delete(token);
    }
  };
}
export default function useUiPalette() {
  const [uiPalette, setValue] = useState("cchat");
  const session = useRef(null);
  if (!session.current) session.current = createUiPaletteSession(setValue);
  return { uiPalette, ...session.current };
}
